import constantsApi from "@api/constant";
import { getCachedData } from "@core/utils/localStorageManager";
import React, { createContext, useEffect, useState } from "react";
export const ConstantsContext = createContext();

export const ConstantsProvider = ({ children }) => {
  const token = getCachedData("access_token");
  const [constants, setConstants] = useState([]);

  useEffect(() => {
    if (!!token) {
      constantsApi.getConstants().then((res) => {
        setConstants(res.content);
      });
    }
  }, [token]);

  return (
    <ConstantsContext.Provider value={constants}>
      {children}
    </ConstantsContext.Provider>
  );
};
